module.exports = __webpack_public_path__ + "static/media/plus-white.9d8cb74b.svg";